import { render, staticRenderFns } from "./LifeCoveredWidget.vue?vue&type=template&id=e8d6e1e0&scoped=true"
import script from "./LifeCoveredWidget.vue?vue&type=script&lang=js"
export * from "./LifeCoveredWidget.vue?vue&type=script&lang=js"
import style0 from "./LifeCoveredWidget.vue?vue&type=style&index=0&id=e8d6e1e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8d6e1e0",
  null
  
)

/* custom blocks */
import block0 from "./LifeCoveredWidget.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports